import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AddressSelector from "../../../../controls/AddressSelector";
import AuthorizationRequired from "../../../../utils/components/AuthorizationRequired";
import BackEnd from "../../../../backend/BackEnd";
import ActionLink from "../../../../controls/ActionLink";

class SearchForm extends Component {
    static propTypes = {
        counters: PropTypes.object,
        onChange: PropTypes.func,
        children: PropTypes.node
    };
    static defaultProps = {};
    state = {
        isLoading: false,
        products: [],
        region: {},
        advertTypeId: null,
        showAllProducts: true,
        productId: -1,
        sortOrder: 'dateDesc'
    };
    getAllProduction = new BackEnd.Production.GetAll(this);

    async componentDidMount() {
        let products = await this.getAllProduction.call();
        const {adertsTypeFilter} = this.props;

        let advertTypeId = adertsTypeFilter == undefined ? null: (adertsTypeFilter == 'sell' ? 1 : 2);
        this.setState({products, advertTypeId}, () => {
            this.updateCriteria(this.state);
        });
    }

    render() {
        const {counters, children} = this.props;

        let totalCountOfBuy = isNaN(counters.totalCountOfBuy)
            ? <i className="fa fa-circle-o-notch fa-spin"/>
            : counters.totalCountOfBuy;
        let totalCountOfSell = isNaN(counters.totalCountOfSell)
            ? <i className="fa fa-circle-o-notch fa-spin"/>
            : counters.totalCountOfSell;
        let totalCountOfMy = isNaN(counters.totalCountOfMy)
            ? <i className="fa fa-circle-o-notch fa-spin"/>
            : counters.totalCountOfMy;

        return (
            <div className={`panel box ${this.state.isLoading ? 'form-loading' : ''}`}
                 id="advert-search-form" style={{overflow: 'visible', position: 'static'}}>
                <div className="box-row">
                    <div className="box-cell p-x-2 p-y-1 bg-black text-xs-center font-size-11 font-weight-semibold">
                        <i className="fa fa-search"/>&nbsp;&nbsp;Поиск
                    </div>
                </div>
                <div className="box-row">
                    <form className="panel-body">
                        <fieldset className="form-group">
                            <AddressSelector className="form-control" placeholder="Любой регион"
                                             precision="region"
                                             value={this.state.region}
                                             onChange={region => this.updateCriteria({region})}/>
                        </fieldset>
                        <fieldset className="form-group">
                            <select className="form-control"
                                    value={this.state.productId}
                                    onChange={event => this.updateProductId(parseInt(event.target.value))}>
                                <option value="-1">-- Любые поддоны --</option>
                                {this.state.products.map(product =>
                                    <option key={product.id}
                                            value={product.id}>{product.fullName}</option>
                                )}
                            </select>
                        </fieldset>
                        <fieldset className="form-group m-b-1">
                            <button type="button" className={`btn btn-primary btn-sm m-r-2 ${this.getClassName(this.state.advertTypeId, null)}`}
                                    onClick={() => this.updateCriteria({advertTypeId: null})}>
                                {this.getIcon(this.state.advertTypeId, null)} Все
                            </button>
                            <button type="button" className={`btn btn-primary btn-sm m-r-2 ${this.getClassName(this.state.advertTypeId, 1)}`}
                                    onClick={() => this.updateCriteria({advertTypeId: 1})}>
                                <span className="btn-label left">{totalCountOfSell}</span>
                                {this.getIcon(this.state.advertTypeId, 1)} Продажа
                            </button>
                            <button type="button" className={`btn btn-primary btn-sm m-r-2 ${this.getClassName(this.state.advertTypeId, 2)}`}
                                    onClick={() => this.updateCriteria({advertTypeId: 2})}>
                                <span className="btn-label left">{totalCountOfBuy}</span>
                                {this.getIcon(this.state.advertTypeId, 2)} Покупка
                            </button>
                            <AuthorizationRequired>
                                <button type="button" className={`btn btn-primary btn-sm ${this.getClassName(this.state.advertTypeId, 4)}`}
                                        onClick={() => this.updateCriteria({advertTypeId: 4})}>
                                    <span className="btn-label left">{totalCountOfMy}</span>
                                    {this.getIcon(this.state.advertTypeId, 4)} Мои
                                </button>
                            </AuthorizationRequired>
                        </fieldset>
                        <div className="row m-b-1">
                            <div className="col-sm-12">
                                <div className="pull-right">
                                    <div className="btn-group">
                                        <button type="button" className="btn btn-sm btn-outline btn-outline-colorless dropdown-toggle"
                                                data-toggle="dropdown">
                                            {this.getSortOrderText()}
                                        </button>
                                        <ul className="dropdown-menu">
                                            <li>
                                                <ActionLink onClick={() => this.updateCriteria({sortOrder: 'dateAsc'})}>
                                                    <i className="fa fa-check" style={this.getSortOrderVisibility('dateAsc')}/>
                                                    &nbsp;Сначала старые
                                                </ActionLink>
                                            </li>
                                            <li>
                                                <ActionLink onClick={() => this.updateCriteria({sortOrder: 'dateDesc'})}>
                                                    <i className="fa fa-check" style={this.getSortOrderVisibility('dateDesc')}/>
                                                    &nbsp;Сначала новые
                                                </ActionLink>
                                            </li>
                                            <li className="divider"/>
                                            <li>
                                                <ActionLink onClick={() => this.updateCriteria({sortOrder: 'priceAsc'})}>
                                                    <i className="fa fa-check" style={this.getSortOrderVisibility('priceAsc')}/>
                                                    &nbsp;Сначала дешевые
                                                </ActionLink>
                                            </li>
                                            <li>
                                                <ActionLink onClick={() => this.updateCriteria({sortOrder: 'priceDesc'})}>
                                                    <i className="fa fa-check" style={this.getSortOrderVisibility('priceDesc')}/>
                                                    &nbsp;Сначала дорогие
                                                </ActionLink>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {children || ''}
                    </form>
                </div>
            </div>
        );
    }

    updateProductId(productId) {
        if (productId === -1) {
            this.updateCriteria({showAllProducts: true, productId: 0});
        }
        else {
            this.updateCriteria({showAllProducts: false, productId});
        }
    }

    getSortOrderText() {
        switch (this.state.sortOrder) {
            case 'dateAsc':
                return 'Сначала старые';
            case 'dateDesc':
                return 'Сначала новые';
            case 'priceAsc':
                return 'Сначала дешевые';
            case 'priceDesc':
                return 'Сначала дорогие';
        }
    }

    getSortOrderVisibility(sortOrder) {
        return this.state.sortOrder !== sortOrder
            ? {visibility: 'hidden'}
            : {};
    }

    getClassName(current, expected)  {
        return current === expected ? '' : 'btn-outline';
    }

    getIcon(current, expected) {
        return <i className={`fa fa-${current === expected ? 'check-' : ''}square-o`}/>;
    }

    updateCriteria(state) {
        const {onChange} = this.props;

        this.setState(state, () => {
            onChange({
                region: this.state.region.strictName,
                advertTypeId: this.state.advertTypeId,
                showAllProducts: this.state.showAllProducts,
                productId: this.state.productId,
                sortOrder: this.state.sortOrder
            });
        });
    }
}

export default SearchForm;


// WEBPACK FOOTER //
// ./src/pages/Adverts/AdvertList/components/SearchForm.js